/**
 * Assembles the cloud app's concrete implementation of the shared TrinetraApi
 * contract, injected at the root via <ApiProvider>. Add one adapter per domain
 * as shared pages are extracted.
 */
import type { TrinetraApi } from '@trinetra/shared';
import { cloudRoleApi } from './roles.adapter';
import { cloudUserApi } from './users.adapter';
import { cloudGroupApi } from './groups.adapter';
import { cloudModelApi } from './models.adapter';
import { cloudDiscoveryApi } from './discovery.adapter';
import { cloudHexAlertsApi } from './hexAlerts.adapter';
import { cloudMapLayoutApi } from './mapLayouts.adapter';
import { cloudGeoMapApi } from './geoMap.adapter';
import { cloudAccessControlApi } from './access-control.adapter';
import { cloudAttendanceApi } from './attendance.adapter';
import { cloudHeatmapApi } from './heatmap.adapter';
import { cloudSearchApi } from './search.adapter';
import { cloudVehicleBlacklistApi } from './vehicleBlacklist.adapter';
import { cloudWatchlistApi } from './watchlist.adapter';
import { cloudCameraImportApi } from './cameraImport.adapter';
import { cloudWallPlaybackApi } from './wallPlayback.adapter';

export function createCloudApi(): TrinetraApi {
  return {
    roles: cloudRoleApi,
    users: cloudUserApi,
    groups: cloudGroupApi,
    models: cloudModelApi,
    discovery: cloudDiscoveryApi,
    hexAlerts: cloudHexAlertsApi,
    mapLayouts: cloudMapLayoutApi,
    geoMap: cloudGeoMapApi,
    accessControl: cloudAccessControlApi,
    attendance: cloudAttendanceApi,
    heatmap: cloudHeatmapApi,
    search: cloudSearchApi,
    vehicleBlacklist: cloudVehicleBlacklistApi,
    watchlist: cloudWatchlistApi,
    wallPlayback: cloudWallPlaybackApi,
    cameraImport: cloudCameraImportApi,
  };
}
